// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase */
import { GuaranteeInput } from "../../../../../../../records/bookingInput"

export const GUARANTEE_BANNER = Object.freeze({
  PAID_META_PARTNER_VI: "paid_meta_partner_vi",
  NOT_PAID_META_PARTNER_VI: "not_paid_meta_partner_vi",
  PAID_VI: "paid_vi",
  PAID_NON_VI: "paid_non_vi",
  NOT_PAID_VI: "not_paid_vi",
  NOT_PAID_NON_VI: "not_paid_non_vi",
  LEGACY: "legacy",
  HIDDEN: "hidden",
})
export const GUARANTEE_TYPES = {
  LEGACY: "legacy",
  PAID: "paid",
  NOT_PAID: "not_paid",
} as const

export type GuaranteeBannerType = typeof GUARANTEE_BANNER[keyof typeof GUARANTEE_BANNER]
export type GuaranteeType = typeof GUARANTEE_TYPES[keyof typeof GUARANTEE_TYPES]

type Guarantee = {
  guaranteeBanner: GuaranteeBannerType
  type: GuaranteeType
} | null

export const mapperGuarantee = (guaranteeInput?: GuaranteeInput | null): Guarantee => {
  // TODO: After https://jira.kiwi.com/browse/MMB-2650, return null
  //  if `guaranteeInput` does not contain property `guarantee_banner`.
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!guaranteeInput || !guaranteeInput.type) return null

  const { guarantee_banner, type } = guaranteeInput

  return {
    guaranteeBanner: guarantee_banner,
    type,
  }
}
